import { pickImage, pickGallery } from "./imagePool";

const slugify = (s) =>
  s.toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");

const NAMES = [
  ["2mtr Flag Pole", "Flags & Poles"],
  ["5 mtr flag pole", "Flags & Poles"],
  ["ABIH7627", "Promotional"],
  ["Acrylic A5- L shape", "Acrylic Products"],
  // ["acrylic customized", "Acrylic Products"],
  ["Acrylic Hinges", "Acrylic Products"],
  ["Acrylic Step customized display for products", "Acrylic Products"],
  ["Aluminium Easel Stand", "Display Stands"],
  ["Aluminum Easel Stand- 2", "Display Stands"],
  ["Application_Tape", "Sheets & Materials"],
  ["box type", "Promotional"],
  ["Brochure Holder A5", "Brochure Holders"],
  ["Brochure holder A4 Size", "Brochure Holders"],
  ["Brochure holder DL Size", "Brochure Holders"],
  ["customize acrylic products", "Acrylic Products"],
  ["customized glorifier", "Display Stands"],
  ["diamond grade", "Sheets & Materials"],
  ["Door Name Holder", "Signage"],
  // ["Double Foam Tape", "Sheets & Materials"],
  ["double sided tape", "Sheets & Materials"],
  // ["double sided tape2", "Sheets & Materials"],
  ["Engraving sheet regular", "Sheets & Materials"],
  ["FIXED POSTER STAND - A3 & A4", "Display Stands"],
  // ["Flex clip", "Sheets & Materials"],
  ["Flying Banner-3", "Banners"],
  ["Frosted Film", "Sheets & Materials"],
  ["frosted", "Promotional"],
  ["Table Flag Stand", "Promotional"],
  ["HARD POUCH", "Bags & Pouches"],
  ["honey comb blue", "Sheets & Materials"],
  ["honey comb", "Sheets & Materials"],
  ["honey comb green", "Sheets & Materials"],
  // ["ID hard pouch 2", "Bags & Pouches"],
  ["ID hard pouch", "Bags & Pouches"],
  ["ID pouch K-1", "Bags & Pouches"],
  ["id soft 2", "Bags & Pouches"],
  // ["ID soft pouch 1", "Bags & Pouches"],
  ["ID soft pouch", "Bags & Pouches"],
  ["ID soft", "Bags & Pouches"],
  // ["IMG_0327", "Promotional"],
  // ["IMG_0328", "Promotional"],
  // ["IMG_0329", "Promotional"],
  // ["IMG_0330", "Promotional"],
  // ["IMG_0331", "Promotional"],
  // ["IMG_0332", "Promotional"],
  // ["IMG_2873", "Promotional"],
  ["Info Board Chrome base - A3", "Signage"],
  ["INFO LINE BOARD 100 X 70", "Signage"],
  ["IVCV5110", "Promotional"],
  ["JWSX6307", "Promotional"],
  ["lanyard 20mm", "Badges"],
  ["LANYARD- 15mm SCREENPRINT", "Badges"],
  ["Laser Engarving Sheet-1", "Sheets & Materials"],
  // ["Laser Engarving Sheet-2", "Sheets & Materials"],
  ["Locator", "Signage"],
  ["Locatot", "Promotional"],
  ["LUXW5313", "Promotional"],
  ["LWCR9120", "Promotional"],
  ["Magnetic name badge", "Badges"],
  ["Micron Sheet (Clear)", "Sheets & Materials"],
  ["Micron sheet (White)", "Sheets & Materials"],
  ["Netted brochure Holder- single sided", "Brochure Holders"],
  ["Netted brochure Holder", "Brochure Holders"],
  ["OKBG1262", "Promotional"],
  ["Plotting paper Roll", "Sheets & Materials"],
  ["POP UP TABLE", "Display Stands"],
  ["Q pole With Retractable", "Flags & Poles"],
  ["Q-pole-with-Rope", "Flags & Poles"],
  ["Raffle Box 120 x 60", "Promotional"],
  ["Raffle Box 30 x 30 x 30cm", "Promotional"],
  ["RAFFLE DRUM 120 x 60", "Promotional"],
  ["Raffle drum 30 x 30 x 30", "Promotional"],
  // ["Raffle Drum 90 x 45cm", "Promotional"],
  ["Raffle drum Table top", "Promotional"],
  // ["RDFL7760", "Promotional"],
  // ["Reel Badges wih Epoxy", "Badges"],
  ["Reel Badges with Epoxy", "Badges"],
  // ["Reel-3", "Badges"],
  ["ROLL UP 150x200cm Print", "Banners"],
  ["Roll Up", "Banners"],
  ["Rotating-Light-Box", "Light Boxes"],
  ["Sales Promotinal Table", "Display Stands"],
  ["Silicon wrist band Pink glow in the dark", "Badges"],
  ["silicon wrist band", "Badges"],
  ["Slim Light Box With Frame", "Light Boxes"],
  ["Slim Light Box", "Light Boxes"],
  ["Snap Frame Mitered Corner- 2", "Light Boxes"],
  ["snap frame with Corner 25mm & 30mm-1", "Light Boxes"],
  ["soft pouch", "Bags & Pouches"],
  ["Square banner 1", "Banners"],
  ["square banner with water Tube", "Banners"],
  ["Square banner", "Banners"],
  ["TABLE - DOOR NAME holder", "Signage"],
  ["Texo double Side Tissue Tape", "Sheets & Materials"],
  ["Texo Red tape - Double Side", "Sheets & Materials"],
  ["UQKI8025", "Promotional"],
  ["Velcro white", "Sheets & Materials"],
  ["Velcro Black", "Sheets & Materials"],
  // ["Velcro-2inch-50mm", "Sheets & Materials"],
  ["wooden black", "Promotional"],
  ["Wooden Easel Stand", "Display Stands"],
  // ["Z type podium 1", "Podiums"],
  ["Z type podium", "Podiums"],
  ["zigzag Brochure Holder A3", "Brochure Holders"],
  // ["Zigzag Brochure holder with Aluminium Case-1", "Brochure Holders"],
  ["Zigzag Brochure holder with Aluminium Case", "Brochure Holders"],
  ["Zigzag Brochure Holder", "Brochure Holders"],
  ["ZigZag Brochure_Stand", "Brochure Holders"],
  ["Diamond grade (Alt)", "Sheets & Materials"],
  ["podium box", "Podiums"],
  // ["Double Side Roll Up", "Banners"],
  ["Flying-Banner", "Banners"],
  ["Flyingbanners", "Banners"],
  ["info-board-black base", "Signage"],
  // ["Rotating Light Box-1", "Light Boxes"],
  ["Rotating Light Box", "Light Boxes"],
  ["Metal Brochure Holder", "Brochure Holders"],

  // Newly added assets (mapped to suitable categories)
  ["Curved Exhibition Display Wall", "Backdrops"],
  ["Curved Fabric Backdrop  Pop-Up Display", "Backdrops"],
  ["Curved Premium Fabric Display", "Backdrops"],
  ["Straight Fabric Backdrop", "Backdrops"],
  ["Straight Fabric Step-and-Repeat Backdrop", "Backdrops"],

  ["Double Banner Pole Stand (V-Shape)", "Banners"],
  ["Mini Banner Stand (Desktop Roll-Up Banner)", "Banners"],
  ["Table Banner Stand (L-Style Banner Stand)", "Banners"],

  ["Floor Flag Poles", "Flags & Poles"],
  ["Gold Floor Flag Pole", "Flags & Poles"],
  ["Table Flag Stand with Flag", "Flags & Poles"],
  ["Teardrop Flags  Feather Flags", "Flags & Poles"],

  ["Queue Barrier Post (Gold Stanchion)", "Stanchions"],

  // Additional newly added assets
  ["Acrylic Brochure Holder", "Brochure Holders"],
  ["Acrylic Raffle Drum", "Promotional"],
  ["Acrylic Table Tent Sign Holder", "Signage"],
  ["Hanging Banner", "Banners"],
  ["Lucky Draw Wheel", "Promotional"],
  ["Napkin & Tissue Holder", "Promotional"],
  ["Roll-Up Banner Base (Retractable Banner Hardware)", "Banners"],
  ["Roll-Up Banner Stand (Retractable Banner)", "Banners"],
  ["Roll-Up Banner Stand", "Banners"],
  ["Slider Door Sign", "Signage"],
  ["Snap Frame", "Signage"],
  ["Table Flags", "Flags & Poles"],
  ["Teardrop Flag", "Flags & Poles"],
];

const buildDescription = (name) =>
  `Premium ${name.toLowerCase()} — crafted with quality materials and engineered for daily commercial use. Perfect for retail, exhibitions, offices and events across the UAE.`;

const buildFeatures = (name, cat) => [
  "Premium-grade materials with consistent finish",
  "Engineered for indoor & light outdoor commercial use",
  "Customisable size, branding and finishing options",
  "Durable build — withstands repeated handling",
  "Fast turnaround with UAE-wide delivery",
  `Ideal for ${cat.toLowerCase()} use cases`,
];

const buildSpecs = (name, cat) => ({
  Category: cat,
  Material: cat.includes("Acrylic") ? "Cast acrylic" : cat.includes("Flag") ? "Aluminium + textile" : "Premium composite",
  Finish: "Matte / Glossy options",
  Customisation: "Available on request",
  "Lead Time": "3–5 working days",
  Warranty: "6 months against manufacturing defects",
});

const buildApplications = () => [
  "Corporate offices & reception areas",
  "Retail & shopping mall displays",
  "Exhibitions, expos & product launches",
  "Hotels, restaurants & hospitality",
  "Banking, healthcare & government lobbies",
];

const buildSizes = (cat) => {
  if (cat === "Brochure Holders") return ["DL", "A5", "A4", "A3", "Custom"];
  if (cat === "Banners") return ["80×200 cm", "100×200 cm", "120×200 cm", "150×200 cm", "200×200 cm"];
  if (cat === "Flags & Poles") return ["2 m", "3 m", "5 m", "Custom"];
  if (cat === "Display Stands") return ["A4", "A3", "A2", "Custom"];
  if (cat === "Acrylic Products") return ["Standard", "Custom"];
  return ["Standard", "Custom"];
};

const buildMaterials = (cat) => {
  if (cat === "Acrylic Products") return ["Cast acrylic", "Extruded acrylic"];
  if (cat === "Flags & Poles") return ["Aluminium", "Steel", "Polyester textile"];
  if (cat === "Sheets & Materials") return ["PVC", "Foam", "Vinyl"];
  if (cat === "Badges") return ["Metal", "Plastic", "Epoxy"];
  return ["Premium composite", "Custom on request"];
};

const buildFAQs = (name) => [
  { q: `Can I customise ${name}?`, a: "Yes — we offer custom sizing, branding, finishing and packaging. Share your spec with our team for a tailored quote." },
  { q: "What is the minimum order quantity?", a: "There's no fixed MOQ for most items. Bulk pricing kicks in from 10+ units." },
  { q: "How fast can you deliver in the UAE?", a: "Standard delivery is 3–5 working days. Express options ship within 24–48 hours where possible." },
  { q: "Do you ship outside the UAE?", a: "Yes — worldwide shipping is available on request. Quotation includes courier and customs handling." },
];

export const PRODUCTS = NAMES.map(([name, category], i) => {
  const slug = slugify(name);
  return {
    id: i + 1,
    name,
    slug,
    category,
    image: pickImage(slug, name, 0),
    gallery: pickGallery(slug, name),
    description: buildDescription(name),
    features: buildFeatures(name, category),
    specifications: buildSpecs(name, category),
    materials: buildMaterials(category),
    sizes: buildSizes(category),
    applications: buildApplications(),
    faqs: buildFAQs(name),
  };
});

export const CATEGORIES_LIST = Array.from(new Set(PRODUCTS.map((p) => p.category))).sort();

export const getProductBySlug = (slug) => PRODUCTS.find((p) => p.slug === slug);

export const getRelated = (slug, n = 4) => {
  const p = getProductBySlug(slug);
  if (!p) return [];
  return PRODUCTS.filter((x) => x.slug !== slug && x.category === p.category).slice(0, n);
};
